require('../../modules/es6.number.epsilon');
module.exports = Math.pow(2, -52);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/epsilon.js
// module id = mcHG
// module chunks = 0